import { render, staticRenderFns } from "./index.vue?vue&type=template&id=96a3565e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=96a3565e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a3565e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/erp-flexible-web21_zo1Z/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96a3565e')) {
      api.createRecord('96a3565e', component.options)
    } else {
      api.reload('96a3565e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=96a3565e&scoped=true&", function () {
      api.rerender('96a3565e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tree/index.vue"
export default component.exports